// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OO66uACT3RFYRV {
  margin-left: var(--ds-space-100, 8px);
}
.E4TmdOGEdW1wjG {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: 1px;
  list-style: none;
}
.vWxdGeDInQeJ7h {
  margin-left: var(--ds-space-100, 8px);
}
.xMXJhPmHJAHOgT {
  border: none;
  background-color: transparent;
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  transition: none;
  border-radius: 0;
  outline: 0;
  background: var(--ds-background-neutral-subtle, #00000000);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  text-align: left;
  text-decoration: none;
}
.xMXJhPmHJAHOgT:hover {
  border: none;
  background-color: transparent;
  box-shadow: none;
  background: var(--ds-background-neutral-subtle-hovered, #091e420f);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.xMXJhPmHJAHOgT:active {
  border: none;
  background-color: transparent;
  box-shadow: none;
  background: var(--ds-background-neutral-subtle-pressed, #091e4224);
  color: var(--ds-text, #172b4d);
}
.xMXJhPmHJAHOgT.X74aBfZ06bqjkj:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .xMXJhPmHJAHOgT.X74aBfZ06bqjkj:focus {
  outline-color: -webkit-focus-ring-color;
}
.xMXJhPmHJAHOgT.X74aBfZ06bqjkj:focus .mac.firefox {
  outline-color: AccentColor;
}
.xMXJhPmHJAHOgT[disabled],
.xMXJhPmHJAHOgT[disabled]:active,
.xMXJhPmHJAHOgT[disabled]:focus,
.xMXJhPmHJAHOgT[disabled]:hover {
  background: transparent;
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
  cursor: not-allowed;
}
.xMXJhPmHJAHOgT[disabled] .bov5WWi78zmxtT svg,
.xMXJhPmHJAHOgT[disabled]:active .bov5WWi78zmxtT svg,
.xMXJhPmHJAHOgT[disabled]:focus .bov5WWi78zmxtT svg,
.xMXJhPmHJAHOgT[disabled]:hover .bov5WWi78zmxtT svg {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
}
.xMXJhPmHJAHOgT[disabled] span[name='check'],
.xMXJhPmHJAHOgT[disabled]:active span[name='check'],
.xMXJhPmHJAHOgT[disabled]:focus span[name='check'],
.xMXJhPmHJAHOgT[disabled]:hover span[name='check'] {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-icon-subtle, #626f86) !important;
}
.xMXJhPmHJAHOgT[disabled] .YKLxVfIanFdp2U,
.xMXJhPmHJAHOgT[disabled]:active .YKLxVfIanFdp2U,
.xMXJhPmHJAHOgT[disabled]:focus .YKLxVfIanFdp2U,
.xMXJhPmHJAHOgT[disabled]:hover .YKLxVfIanFdp2U {
  /* stylelint-disable-next-line declaration-no-important */
  color: var(--ds-text-disabled, #091e424f) !important;
}
.xMXJhPmHJAHOgT:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .xMXJhPmHJAHOgT:focus {
  outline-color: -webkit-focus-ring-color;
}
.xMXJhPmHJAHOgT:focus .mac.firefox {
  outline-color: AccentColor;
}
.G7o4O3Gcjp5Pw9 {
  flex-shrink: 0;
  max-height: 20px;
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var chevron = `OO66uACT3RFYRV`;
export var menu = `E4TmdOGEdW1wjG`;
export var title = `vWxdGeDInQeJ7h`;
export var link = `xMXJhPmHJAHOgT`;
export var linkFocusRing = `X74aBfZ06bqjkj`;
export var icon = `bov5WWi78zmxtT`;
export var description = `YKLxVfIanFdp2U`;
export var iconBefore = `G7o4O3Gcjp5Pw9`;
export default ___CSS_LOADER_EXPORT___;
